export const NEW_REQUEST_PENDING = 'NEW_REQUEST_PENDING';
